import { render, staticRenderFns } from "./InputCodeArea.vue?vue&type=template&id=dd5a1012&"
import script from "./InputCodeArea.vue?vue&type=script&lang=ts&"
export * from "./InputCodeArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports